import { Link } from "react-router-dom";
import { SO_CONG_CU } from "../data/tools.js";
import { SO_QUY_HIEN_THI } from "../data/funds.js";
import { PLAYBOOK_POSTS } from "../data/playbook.js";
import { DA_XUAT_BAN } from "../data/glossary.js";

/**
 * Bốn ô số liệu, mỗi ô dẫn thẳng tới trang tương ứng. Số đếm từ dữ liệu lúc
 * build nên luôn khớp với site. Dùng ở trang chủ và /bat-dau, ngay dưới khung
 * động: người mở link chia sẻ thấy ngay site có gì và bấm vào được.
 */
export const SO_LIEU = [
  { so: SO_CONG_CU, nhan: "công cụ tính toán", to: "/cong-cu" },
  { so: SO_QUY_HIEN_THI, nhan: "nguồn vốn đã kiểm điều kiện", to: "/nguon-von" },
  { so: PLAYBOOK_POSTS.length, nhan: "bài Playbook thực hành", to: "/playbook" },
  { so: DA_XUAT_BAN.length, nhan: "thuật ngữ giải thích dễ hiểu", to: "/thuat-ngu" },
];

export default function SoLieuNhanh({ className = "" }) {
  return (
    <nav className={`home-so-lieu ${className}`} aria-label="Có gì trên Fundraising.vn">
      {SO_LIEU.map((x) => (
        <Link className="home-so" to={x.to} key={x.to}>
          <b>{x.so}</b>
          <span>{x.nhan}</span>
        </Link>
      ))}
    </nav>
  );
}
